import * as React from "react";
import { Field } from "typings/index";
import { 
    Dialog,
    PrimaryButton, 
    DialogFooter, 
    DefaultButton, 
    SelectionMode, 
    DetailsList, 
    CheckboxVisibility, 
    IColumn, 
    Selection 
} from "office-ui-fabric-react/lib";

export interface Props
{
    properties: Field[];
    selectedProperties: string[];
    hideDialog: () => void;
    onSave: (selectedProperties: string[]) => void;
}


const PropertyPickerDialog: React.FunctionComponent<Props> = props =>
{
    const [selectedProperties, setSelectedProperties] =  React.useState<string[]>(props.selectedProperties);

    const onSave = () =>
    {
        props.onSave(selectedProperties);
    };

    const onSelectionChanged = () =>
    {
        const selected: Field[] = selection.getSelection();
        setSelectedProperties([...selectedProperties, ...selected.map(x => x.field.name )]);
     
    };

    const selection: any = new Selection({ 
        onSelectionChanged,
    });

    const columns: IColumn[] = [
        { key: "column2", name: "name", fieldName: "item.field.label._DEFAULT", minWidth: 1, isResizable: true,
            onRender: (item: Field) => 
            {
               return <span>{item.field.label._DEFAULT}</span>;
            }
        }

    ];

    return (
        <Dialog hidden={false} onDismiss={props.hideDialog} minWidth={400}>
            <div style={{overflowY: "scroll", height: "500px"}}>
                <DetailsList
                    
                    items={props.properties}
                    columns={columns}
                    isHeaderVisible={true}
                    selectionMode={SelectionMode.multiple}
                    selection={selection}
                    checkboxVisibility={CheckboxVisibility.always}
                    checkboxCellClassName="checkbox-square"   
                                    
                />
            </div>
          
           <DialogFooter>
                <PrimaryButton onClick={onSave} text="Save" />
                <DefaultButton onClick={props.hideDialog} text="Cancel" />
            </DialogFooter>
        </Dialog>
    );
    
};

export default PropertyPickerDialog;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/propertyPicker/PropertyPickerDialog.tsx